import { AfterViewInit, Component, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { BrandVariable } from 'app/account/brand-variable';
import Renderer2Helpers from 'app/campaign/widget-editor/widget-editor-canvas/components/renderer2-helpers';

@Component({
  selector: 'app-brand-settings-preview',
  templateUrl: './brand-settings-preview.component.html',
  styleUrl: './brand-settings-preview.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BrandSettingsPreviewComponent implements AfterViewInit {
  @ViewChild('brandSettingsPreviewWidget') brandSettingsPreviewWidgetRef;
  @Input() isBrandVarPageForTemplatePage: boolean;
  @Input() set brandVariablesPreview(data) {
    if (data.brandVariablesPreview && data.selectedTab !== undefined) {
      this.brandVariables = data.brandVariablesPreview;
      this.selectedTab = data.selectedTab;
      this.initStyleVariables(data.brandVariablesPreview);
    }
  }
  public brandVariables: BrandVariable;
  public selectedTab: number;

  ngAfterViewInit(): void {
    if (this.brandVariables) {
      this.initStyleVariables(this.brandVariables);
    }
  }

  private initStyleVariables(brandVariables) {
    if (this.brandSettingsPreviewWidgetRef) {
      const brandSettingsPreviewContentEl = this.brandSettingsPreviewWidgetRef.nativeElement;
      brandSettingsPreviewContentEl.style.cssText += `
        /* Headline */
        --fontHeadline: ${brandVariables.headline?.textProperties.font};
        --fontSizeHeadline: ${brandVariables.headline?.textProperties.fontSize};
        --fontWeightHeadline: ${brandVariables.headline?.textProperties.fontWeight};
        --lineHeightHeadline: ${brandVariables.headline?.textProperties.lineHeight};
        --letterSpacingHeadline: ${brandVariables.headline?.textProperties.letterSpacing};
        --colorHeadline: ${brandVariables.headline?.color};

        /* Text */
        --fontText: ${brandVariables.text?.textProperties.font};
        --fontSizeText: ${brandVariables.text?.textProperties.fontSize};
        --fontWeightText: ${brandVariables.text?.textProperties.fontWeight};
        --lineHeightText: ${brandVariables.text?.textProperties.lineHeight};
        --letterSpacingText: ${brandVariables.text?.textProperties.letterSpacing};
        --colorText: ${brandVariables.text?.color};

        /* Button */
        --fontButton: ${brandVariables.button?.textProperties.font};
        --fontSizeButton: ${brandVariables.button?.textProperties.fontSize};
        --fontWeightButton: ${brandVariables.button?.textProperties.fontWeight};
        --lineHeightButton: ${brandVariables.button?.textProperties.lineHeight};
        --letterSpacingButton: ${brandVariables.button?.textProperties.letterSpacing};
        --colorButton: ${brandVariables.button?.color};
        --backgroundButton: ${brandVariables.button?.backgroundColor};
        --borderColorButton: ${brandVariables.button?.border?.color};
        --borderWidthButton: ${brandVariables.button?.border?.width}px;
        --radiusButton: ${brandVariables.button?.radius.roundValue}px;
        --paddingButton: ${Renderer2Helpers.getStyleFromFourSideStyling(brandVariables.button?.padding)};
        --marginButton: ${Renderer2Helpers.getStyleFromFourSideStyling(brandVariables.button?.margin)};
        --heightButton: ${brandVariables.button?.height}px;
        --alignButton: ${brandVariables.button?.alignment};

        /* Input */
        --fontInput: ${brandVariables.input?.textProperties.font};
        --fontSizeInput: ${brandVariables.input?.textProperties.fontSize};
        --fontWeightInput: ${brandVariables.input?.textProperties.fontWeight};
        --lineHeightInput: ${brandVariables.input?.textProperties.lineHeight};
        --letterSpacingInput: ${brandVariables.input?.textProperties.letterSpacing};
        --colorInput: ${brandVariables.input?.color};
        --backgroundInput: ${brandVariables.input?.backgroundColor};
        --borderColorInput: ${brandVariables.input?.border?.color};
        --borderWidthInput: ${brandVariables.input?.border?.width}px;
        --radiusInput: ${brandVariables.input?.radius?.roundValue}px;
        --paddingInput: ${Renderer2Helpers.getStyleFromFourSideStyling(brandVariables.input?.padding)};
        --marginInput: ${Renderer2Helpers.getStyleFromFourSideStyling(brandVariables.input?.margin)};
        --heightInput: ${brandVariables.input?.height}px;

        /* Label */
        --fontLabel: ${brandVariables.label?.textProperties.font};
        --fontSizeLabel: ${brandVariables.label?.textProperties.fontSize};
        --fontWeightLabel: ${brandVariables.label?.textProperties.fontWeight};
        --lineHeightLabel: ${brandVariables.label?.textProperties.lineHeight};
        --letterSpacingLabel: ${brandVariables.label?.textProperties.letterSpacing};
        --colorLabel: ${brandVariables.label?.color};

        /* Canvas */
        --backgroundCanvas: ${brandVariables.canvas?.backgroundColor};
        --radiusCanvas: ${brandVariables.canvas?.radius.roundValue}px;
        --closeButtonColor: ${brandVariables.canvas?.closeButtonColor};
      `;
    }
  }

  get isFormDesign() {
    if (this.selectedTab !== undefined) {
      if (this.isBrandVarPageForTemplatePage) {
        return this.selectedTab === 1;
      } else {
        return this.selectedTab === 2;
      }
    }
  }
}
